import { useCallback, useEffect, useState } from 'react'

import { Progress, ProgressProps } from '@mantine/core'
import { EmblaCarouselType } from 'embla-carousel'

import useStyles from './index.styles'

type Props = {
  embla: EmblaCarouselType | null
} & ProgressProps

const CarouselProgressBar = ({ embla, styles, ...rest }: Props) => {
  const { classes } = useStyles(undefined, {
    name: 'CarouselProgressBar',
    styles,
  })
  const [scrollProgress, setScrollProgress] = useState(0)
  const handleScroll = useCallback(() => {
    if (!embla) return
    const progress = Math.max(0, Math.min(1, embla.scrollProgress()))
    setScrollProgress(progress * 100)
  }, [embla, setScrollProgress])

  useEffect(() => {
    if (embla) {
      embla.on('scroll', handleScroll)
      handleScroll()
    }
  }, [embla])

  return (
    <Progress
      value={scrollProgress}
      classNames={{
        bar: classes.bar,
        root: classes.root,
      }}
      size="sm"
      {...rest}
    />
  )
}
export { CarouselProgressBar }
